import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-5 pt-24 text-center noise-overlay" data-testid="not-found-page">
      <p className="font-display text-7xl sm:text-9xl font-extrabold uppercase tracking-tight text-outline" style={{ WebkitTextStroke: "1.5px #333" }}>
        404
      </p>
      <p className="mt-6 font-mono text-xs tracking-[0.35em] text-neutral-500">THIS PAGE NEVER MADE THE OUTFIT.</p>
      <Link to="/" data-testid="not-found-home-link"
        className="mt-10 border border-wire px-10 py-4 font-mono text-[11px] tracking-[0.35em] text-neutral-300 transition-colors hover:border-white hover:text-white">
        BACK TO HOME
      </Link>
    </div>
  );
}
